import { render, staticRenderFns } from "./vehicle-registation-card.vue?vue&type=template&id=440f793a&"
import script from "./vehicle-registation-card.vue?vue&type=script&lang=js&"
export * from "./vehicle-registation-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports